import { FileInput } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/atoms/Tooltip';
import { useDocumentNavigation } from '@/hooks/useOpenDocViewer';
import { useStore } from '@/store';

export const FullDocLink = ({ caseId, docId }: { caseId: string; docId: string }) => {
  const navigate = useNavigate();
  const { referenceDrawer, closeReferenceDrawer } = useStore();

  return (
    <TooltipProvider delayDuration={0} skipDelayDuration={0}>
      <Tooltip>
        <TooltipTrigger
          onClick={() => {
            closeReferenceDrawer();
            navigate(`/app/chronos/case-editor/data/documents?caseId=${caseId}&docId=${docId}`);
          }}
        >
          <div className="group flex cursor-pointer items-center rounded-lg border-2 border-blue-300 bg-blue-50 px-1.5 py-1 shadow-xl transition-all hover:border-blue-400 hover:bg-blue-100">
            <FileInput className="h-4 w-4 text-blue-600 transition-transform group-hover:scale-110" />
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>View in documents page</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
